import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';

/**
 * Fixed bottom bar: a persistent responsible-trading notice on every screen,
 * plus a full-width CTA on mobile once the visitor scrolls past the hero.
 */
export function BottomBar() {
  const [showCta, setShowCta] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setShowCta(window.scrollY > 560);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-brand-950/95 backdrop-blur-xl" data-id="element-27" data-mp="9jvde05jvikj">
      <AnimatePresence initial={false} data-id="element-28" data-mp="4m27z9c2mslb">
        {showCta && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="overflow-hidden sm:hidden" data-id="element-29" data-mp="hm7jnl88ddh">
            <div className="px-4 pt-3" data-id="element-30" data-mp="3vtrurpqrhcor">
              <CTAButton label="Abrir cuenta" location="sticky_mobile" size="md" variant="white" className="w-full" data-id="element-31" data-mp="3vut5tu7s1z6h" />
            </div>
          </motion.div>}
      </AnimatePresence>

      <p className="mx-auto flex max-w-[1240px] items-start justify-center gap-2 px-4 py-2.5 text-center text-[11px] leading-snug text-white/70 sm:items-center sm:text-[12.5px]" data-id="element-32" data-mp="dnwq6j42uiss">
        <InfoIcon className="mt-px h-3.5 w-3.5 shrink-0 text-white/60 sm:mt-0" aria-hidden="true" data-id="element-33" data-mp="4lnj6380p7k5" />
        <span data-id="element-34" data-mp="9k73y0avkdax">
          <strong className="font-semibold text-white" data-id="element-35" data-mp="9jp0ojpsoyti">Opera con responsabilidad.</strong>{' '}
          El trading implica riesgos y puedes perder el capital invertido.{' '}
          <a href="#faq" className="text-brand-200 underline underline-offset-2 transition-colors duration-200 ease-expo hover:text-white" data-id="element-36" data-mp="2ucsk8bmmx5wt">
            Conoce los riesgos
          </a>
        </span>
      </p>
    </div>;
}